import { render } from "./BalBtn.vue?vue&type=template&id=632e85a2&scoped=true&ts=true"
import script from "./BalBtn.vue?vue&type=script&lang=ts"
export * from "./BalBtn.vue?vue&type=script&lang=ts"

import "./BalBtn.vue?vue&type=style&index=0&id=632e85a2&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-632e85a2"]])

export default __exports__